<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">

    <div class="entity-config-shell d-flex flex-column gap-4 gap-lg-3 mx-auto mt-4">

        <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
            <div class="entity-config-top-hero px-2 px-md-3 py-3">
                <div class="row g-2 align-items-start flex-nowrap">
                    <div class="col">
                        <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">
                            Notifications
                        </h1>

                        <p class="entity-page-subtitle text-white mb-0">
                            Define what triggers it, who hears about it, and how.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        </div>
      </div>
     <div class="container-fluid mt-4">
        <div class="d-flex-1  mb-1" >

            <button
                class="btn notification-step-btn "
                :class="{ active: active_step === 1 }"
                @click="active_step = 1">

                Trigger
            </button>

            <button
                class="btn notification-step-btn"
                :class="{ active: active_step === 2 }"
                @click="active_step = 2">
                Recipient
            </button>

            <button
                class="btn notification-step-btn"
                :class="{ active: active_step === 3 }"
                @click="active_step = 3">
                Channel
            </button>

            <button
                class="btn notification-step-btn"
                :class="{ active: active_step === 4 }"
                @click="active_step = 4">
                Message
            </button>

            <button
                class="btn notification-step-btn"
                :class="{ active: active_step === 5 }"
                @click="active_step = 5">
                Scope &amp; Review
            </button>

        </div>

</div>

               <div v-show="active_step === 1">
                <div class="row g-4 mt-2" >

                    <div class="col-lg-12">

                        <div class="card border rounded-4 shadow-sm h-100 mb-2">

                            <div class="card-body p-4 mb-4" >

                                <p class="fw-bold mt-2 text-l">
                                    What starts this notification?
                                </p>

                                <p class="text-secondary">
                                    Pick the event source and event type.
                                </p>

                                <div class="row g-4">

                                    <div class="col-md-6">

                                        <label class="form-label fw-semibold">
                                            Event Source
                                        </label>

                                        <select class="form-select">
                                            <option>Choose event source</option>
                                            <option>Risk register</option>
                                             <option>form submission</option>
                                             <option>E-signing</option>
                                             <option>Entity review</option>
                                        </select>

                                    </div>

                                    <div class="col-md-6">

                                        <label class="form-label fw-semibold">
                                            Event Type
                                        </label>

                                        <select class="form-select">
                                            <option>Choose event source first</option>
                                            <option>Risk created</option>
                                            <option>Risk overdue</option>
                                        </select>

                                    </div>

                                </div>

                                <div class="mt-4">



                                    <label class="form-label fw-semibold">
                                        Conditions
                                        <span class="text-secondary fw-normal">
                                            (optional)
                                        </span>
                                    </label>
 <div v-for="(condition, index) in conditions" :key="index"
       class="d-flex align-items-center gap-4 bg-light p-3 rounded-3 mb-2">
       <select class="form-select" v-model="condition.entity_type">
      <option disabled value="">Entity type</option>
      <option>Risk score</option>
      <option>Owner Department</option>
      <option>priority</option>
      <option>Status</option>
    </select>

    <select class="form-select " v-model="condition.operator">
      <option>equals</option>
      <option>not equals</option>
      <option>is greater than</option>
      <option>is less than</option>
      <option>Contain</option>
    </select>

    <input type="text" class="form-control w-50px" v-model="condition.value" placeholder="Value" />

    <!-- Small trash icon button -->
    <button class="btn1 btn-link "
            
            @click="remove_condition(index)">
      <i class="bi bi-trash"></i>
    </button>
  </div>
  <button class="btn btn-outline-secondary w-100 py-3 rounded-3" @click="add_condition">
        + Add Condition
      </button>

                                </div>

                            </div>
                            

                        </div>

                    </div>
</div>
</div>

<section>
  <div v-show="active_step === 2">
  <div class="card border rounded-4 shadow-sm h-100 mt-4">
    <div class="card-body p-4 mt-0">
      <p class="fw-bold mt-2 text-l">Who should be notified?</p>
      <p class="text-secondary">
        Add one or more recipient groups. Each can be a role, a specific person, or someone resolved dynamically from the trigger.
      </p>

      
      <div v-for="(recipient, index) in recipient_groups" :key="index" class="row g-4 mb-3">
        <div class="col-md-5">
          <label class="form-label  fw-semibold">Role Type</label>
          <select class="form-select " v-model="recipient.role_type">
            <option disabled value="">Choose a Role Type</option>
            <option>Specific Person</option>
            <option>Dynamic Person</option>
          </select>
        </div>

        <div class="col-md-5">
          <label class="form-label fw-semibold">Role Name</label>
          <select class="form-select w-100" v-model="recipient.role_name">
            <option disabled value="">Choose a Role</option>
            <option>Compliance Officer</option>
            <option>Risk Owner</option>
            <option>Department Head</option>
            <option>Administrator</option>
          </select>
        </div>

        <!-- Remove button -->
        <button class="btn-btn-link ms-3  "
              @click="remove_recipient(index)">
        <i class="bi bi-trash" ></i>
      </button>
      </div>

      <!-- Add new recipient group -->
      <button class="btn btn-outline-secondary w-100 py-3 rounded-3" @click="add_recipient_group">
        + Add Recipient Group
      </button>
    </div>
  </div>
</div>

</section>

<div v-show="active_step === 3">
    <div class="row g-2 mt-2">

        <div class="col-lg-12 ">

            <div class="card shadow-sm border-0 rounded-4">

                <div class="card-body p-5">

                    <p class="fw-bold mt-2 text-l">
                        How should it be delivered?
                    </p>

                    <p class="text-muted mb-4">
                        Select one or more channels. Each can be configured once selected.
                    </p>

                   <div class="row g-1 justify-content-center">

  <div class="channel-container">

    <label class="channel-card">
        <input type="checkbox" class="form-check-input channel-check"
               value="email" v-model="selected_channels">

        <i class="bi bi-envelope-fill channel-icon"></i>
        <h5>Email</h5>
    
    </label>

    <label class="channel-card">
        <input type="checkbox" class="form-check-input channel-check"
               value="in_app" v-model="selected_channels">

        <i class="bi bi-phone-fill channel-icon"></i>
        <h5>In-App</h5>
    </label>

    <label class="channel-card">
        <input type="checkbox" class="form-check-input channel-check"
               value="sms" v-model="selected_channels">

        <i class="bi bi-chat-dots-fill channel-icon"></i>
        <h5>SMS</h5>
    </label>

    <label class="channel-card">
        <input type="checkbox" class="form-check-input channel-check"
               value="webhook" v-model="selected_channels">

        <i class="bi bi-globe channel-icon"></i>
        <h5>Webhook</h5>
    </label>

</div>

            </div>
         </div>
       </div>
     </div>
   </div>
</div>

<section>
  <div v-show="active_step === 4">
  <div class="row g-4 mt-2">

                    <div class="col-lg-12 mb-2">

                        <div class="card border rounded-4 shadow-sm h-100">

                            <div class="card-body p-4">

                                <small class="text-uppercase fw-bold text-primary">
                                    Step 4
                                </small>

                                <h3 class="fw-bold mt-2">
                                    send the Message
                                </h3>

                                <p class="text-secondary">
                                   Email and in-app reuse what already exists — just pick which one applies. SMS and webhook are written here.
                                </p>

                                <div class="row g-4">

                                    <div class="col-md-6">

                                     <div class="space-y-2">
                                     </div>
                                    </div>
                                    <h6>Write your text Message</h6>
                                   <div class="col-12 mt-2"><label class="workflow-summary-label mb-1"></label><textarea  rows="6" class="w-100" ></textarea></div>

                                </div>
                            </div>
                          </div>
                      </div>
                  
</div>
</div>
<div v-show="active_step === 5">

    <div class="row g-4 mt-2">

        <div class="col-lg-12">

            <div class="card border rounded-4 shadow-sm h-100">

                <div class="card-body p-4">

                    <small class="text-uppercase fw-bold text-primary">
                        Step 5
                    </small>

                    <h3 class="fw-bold mt-2">
                        Scope & Review
                    </h3>

                    <p class="text-secondary mb-4">
                        Bind this rule to specific templates, forms or rules. Leave blank to apply everywhere.
                    </p>

                    <div class="row g-4">

                        <div class="col-md-4">
                            <label class="form-label fw-semibold">
                                Templates
                            </label>

                            <select class="form-select">
                                <option>User Onboarding</option>
                                <option>Password Reset</option>
                            </select>
                        </div>

                        <div class="col-md-4">
                            <label class="form-label fw-semibold">
                                Forms
                            </label>

                            <select class="form-select">
                                <option>Contact Sales</option>
                                <option>Beta Application</option>
                            </select>
                        </div>

                        <div class="col-md-4">
                            <label class="form-label fw-semibold">
                                Rules
                            </label>

                            <select class="form-select">
                                <option>Compliance Auto-Reject</option>
                                <option>Tier 1 Routing</option>
                            </select>
                        </div>

                    </div>

                    <hr class="my-4">

                    <h5 class="fw-bold mb-3">
                        Review Summary
                    </h5>

                    <div class="card border rounded-3 mb-3">

                        <div class="card-body">

                            <h6 class="text-primary">
                                Trigger
                              
                            </h6>

                            <p class="mb-1">
                                Form Submission → Form Submitted
                               
                            </p>

                            <small class="text-muted">
                                0 condition(s) defined
                                
                            </small>

                        </div>

                    </div>

                    <div class="card border rounded-3 mb-3">

                        <div class="card-body">

                            <h6 class="text-primary">
                                Recipients
                            </h6>

                            <p class="mb-0">
                                Selected Recipient Groups
                               
                            </p>

                        </div>

                    </div>

                    
                </div>

            </div>

        </div>

    </div>

</div>


</section>
